// extracted by mini-css-extract-plugin
export default {"container":"RegionsView_container__nnRSU","tabsContainer":"RegionsView_tabsContainer__Tc85x"};